<template>
    <div class="box">
        <div class="left">
            <img src="/img/create_offer/sablona_na_mieru.png" alt="obrazok">
        </div>
        <div class="center">
            <h2>Chceš vlastnú <span> unikátnu šablónu</span>  ?</h2>
            <p>
                PREMIUM používateľom ponúkame možnosť  
                tvorby šablóny na mieru. Vieš sa 
                tak úplne odlíšiť od ostatných. 
            </p>
        </div>
        <div id="cta-sablona-na-mieru" class="right" @click="openModal">
            Mám záujem o šablónu na mieru
        </div>
        <div v-if="modal" id="myModal" class="modal">
            <div class="modal-content" >
                <span class="close" @click="modal = false">×</span>
                <h1>Vlastná šablóna na mieru</h1>
                <p>
                    Chceš svoje cenové ponuky úplne odlíšiť od ostatných?
                    Vypracujeme ti návrh šablóny na mieru. <br><br> 
                    Stačí vyplniť zopár informácií a tvoje predstavy. 
                    My sa ti ozveme s nezáväznou ponukou.
                </p>
                <div class="form-floating mb-3">
                    <input v-model="email" type="email" :style="errors.email ? 'border: 1px solid red' : ''" class="form-control" id="floatingInput" placeholder="E-mail">
                    <label for="floatingInput">E-mail</label>
                </div>
                <div class="form-floating mb-3">
                    <input v-model="tel" type="tel" class="form-control" id="floatingInput" placeholder="Telefónne číslo">
                    <label for="floatingInput">Telefónne číslo</label>
                </div>
                <div class="form-floating textarea">
                    <textarea v-model="notes" class="form-control text-area" placeholder="Pripomienky, požiadavky" id="floatingTextarea2"></textarea>
                    <label for="floatingTextarea2">Pripomienky, požiadavky</label>
                </div>
                <div class="odoslat" @click="send">
                    Nezáväzne odoslať
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data() {
            return {
                modal: false,
                email: "",
                tel: "",
                notes: "",
                errors: {}
            }
        },
        methods: {
            send(){
                this.errors = {}
                if(this.email == ""){
                    this.errors.email = true
                }
                if(!this.errors.email){
                    axios.post(`/api/sablona_na_mieru_email`, {
                        'email': this.email,
                        'tel': this.tel,
                        'notes': this.notes
                    })
                    .then(response => {
                        this.modal = false,
                        this.notes = ""
                        this.$toast.success("Nezáväzná ponuka pre vlastnú šablónu bola odoslaná.", { timeout: 2038,});
                        const gtmEventData = {
                            event: 'email_quote_sent',
                            'Event category': 'email',
                            'Event action': 'successfull_sent_email',
                            'Event label': 'template_offer_for_user_email'
                        };
                        this.$gtm.push(gtmEventData);
                    });
                }
            },
            openModal() {
                this.modal = true
                this.$gtm.push({ 
                    event: 'button',
                    'Event category': "button",
                    'Event action': "click",
                    'Event label': "cta-sablona-na-mieru"
                })
            }
        },
        watch: {
            'data.email': function() {
                if(this.data.email){
                    this.email = this.data.email
                }
            },
            'data.cislo': function() {
                if(this.data.cislo){
                    this.tel = this.data.cislo
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
*{
    font-family: Roboto;
}
.box{
    width: 100%;
    height: auto;
    background: #E9FFFB;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 40px 0 40px;
    margin-bottom: 37px;
    @media screen and (max-width: 700px) {
        display: block;
        text-align: center;
        padding-bottom: 10px;
    }
    .center{
        @media screen and (max-width: 950px) {
            margin-left: 10px;
        }
        @media screen and (max-width: 700px) {
            margin: 20px 0;
        }
        h2{
            @media screen and (max-width: 700px) {
                margin-bottom: 10px;
            }
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 21px;
            display: flex;
            align-items: center;
            color: #212541;
            span{
                margin: 0 5px;
                color: #F3385A;
            }
            @media screen and (max-width: 700px) {
                width: fit-content;
                margin: 0 auto;
            }
        }
        p{
            width: 359px;
            @media (max-width: 600px) {
                width: 95%;
            }
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 27px;
            color: #9598A7;
            @media screen and (max-width: 950px) {
                width: 80%;
            }
            @media screen and (max-width: 700px) {
                margin: 0 auto;
            }
        }
    }
    .right{
        cursor: pointer;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        text-decoration-line: underline;
        color: #000000;
        @media screen and (max-width: 700px) {
            margin-bottom: 20px;
        }
    }
}
.modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed; 
    z-index: 1; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background-color: rgb(0,0,0); 
    background-color: rgba(0,0,0,0.4); 
    z-index: 1111;
    .modal-content {
        position: relative;
        background-color: #F2F7FB;
        border: none;
        padding: 33px 0 0 0;
        width: 762px;
        height: 714px;
        text-align: center;
        @media (max-width: 600px) {
            width: 95%;
            height:95%;
        }
        .close{
            cursor: pointer;
            position: absolute;
            right: 15px;
            top: 10px;
            font-style: normal;
            font-weight: bold;
            font-size: 23px;
            color: #000000;
        }
        h1{
            font-style: normal;
            font-weight: bold;
            font-size: 36px;
            line-height: 42px;
            color: #000000;
        }
        p{
            margin: 28px auto;
            width: 540px;
            @media (max-width: 600px) {
                width: 95%;
                margin: 10px auto;
            }
            font-style: normal;
            font-weight: 500;
            font-size: 22px;
            line-height: 150%;
            color: #9598A7;
        }
        .form-floating{
            width: 473px;
            height: 63px;
            margin: 0 auto;
            @media (max-width: 600px) {
                width: 95%;
            }
            &.textarea{
                height: 150px;
                &.text-area{
                    height: 150px;
                    @media (max-width: 600px) {
                        height: 120px !important;
                    }
                }
            }
            label{
                height: auto;
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #212541; 
                display: flex;
                align-items: center;
            }
        }
        
        .odoslat{
            cursor: pointer;
            margin: 8px auto 0 auto;
            width: 474px;
            @media (max-width: 600px) {
                width: 95%;
            }
            height: 55px;
            background: #2ED8B6;
            border-radius: 4px;

            display: flex;
            align-items: center;
            justify-content: center;

            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            color: #FFFFFF;
        }
    }
}


</style>